import React, { useContext } from "react";

import { DataContext } from "../../../../../../../providers/ElectricityCheckoutDataProvider";
import Input from "../../../../../../shared/forms/NewInput";
import { SalutationSelect } from "../../../../../../shared/forms/NewSelect";
import Margin from "../../../../../../shared/Margin";
import Headline from "../../../../../../shared/NewHeadline";

const ContactData = () => {
    const dataContext = useContext(DataContext);

    const { deliveryAddressData } = dataContext.data;
    const {
        setDeliveryAddressData,
        addFormError,
        clearFormError,
        hasFormErrorAt,
    } = dataContext.actions;

    const handleChange = (event) => {
        setDeliveryAddressData({
            ...deliveryAddressData,
            ...{ [event.target.name]: event.target.value },
        });
    };

    return (
        <React.Fragment>
            <Headline>Kontaktdaten</Headline>
            <div className="field">
                <div className="control">
                    <Input
                        placeholder="Firma (optional)"
                        name="company"
                        onChange={handleChange}
                        value={deliveryAddressData.company}
                        validation="company"
                        onError={() => addFormError("company")}
                        onErrorSolved={() => clearFormError("company")}
                    />
                </div>
            </div>
            <div className="field is-full-width">
                <div className="field">
                    <div className="control">
                        <SalutationSelect
                            name="salutation"
                            onChange={handleChange}
                            value={deliveryAddressData.salutation}
                        />
                    </div>
                </div>
                <div className="field is-full-width">
                    <div className="control">
                        <Input
                            placeholder="Vorname"
                            name="firstname"
                            onChange={handleChange}
                            value={deliveryAddressData.firstname}
                            validation="name"
                            forceError={hasFormErrorAt("firstname")}
                            onError={() => addFormError("firstname")}
                            onErrorSolved={() => clearFormError("firstname")}
                        />
                    </div>
                </div>
            </div>

            <div className="field">
                <div className="control">
                    <Input
                        placeholder="Nachname"
                        name="lastname"
                        onChange={handleChange}
                        value={deliveryAddressData.lastname}
                        validation="name"
                        forceError={hasFormErrorAt("lastname")}
                        onError={() => addFormError("lastname")}
                        onErrorSolved={() => clearFormError("lastname")}
                    />
                </div>
            </div>
            <div className="field">
                <div className="control">
                    <Input
                        placeholder="Geburtsdatum(tt.mm.jjjj)"
                        name="birthdate"
                        onChange={handleChange}
                        value={deliveryAddressData.birthdate}
                        validation="birthdate"
                        forceError={hasFormErrorAt("birthdate")}
                        onError={() => addFormError("birthdate")}
                        onErrorSolved={() => clearFormError("birthdate")}
                    />
                </div>
            </div>
            <Margin top="20" className="field">
                <div className="control">
                    <Input
                        placeholder="E-Mail"
                        name="email"
                        onChange={handleChange}
                        value={deliveryAddressData.email}
                        validation="email"
                        forceError={hasFormErrorAt("email")}
                        onError={() => addFormError("email")}
                        onErrorSolved={() => clearFormError("email")}
                    />
                </div>
            </Margin>
            <div className="field">
                <div className="control">
                    <Input
                        placeholder="Telefonnummer"
                        name="phone"
                        onChange={handleChange}
                        value={deliveryAddressData.phone}
                        validation="phone"
                        forceError={hasFormErrorAt("phone")}
                        onError={() => addFormError("phone")}
                        onErrorSolved={() => clearFormError("phone")}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default ContactData;
